import React, { useState } from 'react';
import { useImpersonationStore } from '../../stores/impersonationStore';
import { useAuthStore } from '../../stores/authStore';
import { authService } from '../../services/authService';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, originalToken, originalUser } =
    useImpersonationStore();
  const { restoreFromImpersonation } = useAuthStore();
  const [loading, setLoading] = useState(false);

  if (!isImpersonating) {
    return null;
  }

  const handleBackToAdmin = async () => {
    setLoading(true);
    try {
      await authService.endImpersonation();
    } catch {
      // best-effort, don't block on failure
    }
    useImpersonationStore.getState().endImpersonation();
    // restore original token in localStorage
    if (originalToken) {
      localStorage.setItem('token', originalToken);
    }
    // restore auth store
    restoreFromImpersonation(originalToken!, originalUser!);
    // Full page load so the app re-bootstraps as the original admin and the
    // role-scoped routes evaluate with the restored identity on first render
    // (a client-side navigate races the auth restore → transient /unauthorized).
    // '/' → DashboardRedirect routes to the admin's home by role.
    window.location.assign('/');
  };

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-400 text-amber-900 px-4 py-2 flex items-center justify-between shadow-md text-sm">
        <div className="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <span className="font-semibold">Viewing as</span>
          <span>
            {impersonatedUser?.first_name} {impersonatedUser?.last_name}
          </span>
          <span className="opacity-70">
            ({impersonatedUser?.role?.replace('_', ' ')})
          </span>
        </div>
        <button
          onClick={handleBackToAdmin}
          disabled={loading}
          className="bg-amber-900 text-amber-50 px-3 py-1 text-xs font-semibold hover:bg-amber-800 disabled:opacity-50"
        >
          {loading ? 'Restoring\u2026' : '\u2190 Back to admin'}
        </button>
      </div>
      <div className="h-10" />
    </>
  );
};

export default ImpersonationBanner;
